import { render, staticRenderFns } from "./SurveyAlternativesManagerDialog.vue?vue&type=template&id=db8fea2e"
import script from "./SurveyAlternativesManagerDialog.vue?vue&type=script&lang=ts"
export * from "./SurveyAlternativesManagerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports